module.exports = __webpack_public_path__ + "media/images/user_icon-1863b2c9.svg";